// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1p87n","header":"MessagesList_header__2T8UR","chat":"MessagesList_chat__2G-kJ"};